import { axiosInstance } from "api/axios";
import statusService from "api/statusService";
import tagsService from "api/tagsService";
import Loading from "components/Loading";
import MessageCard from "components/MessageCard";
import KeysContext from "contexts/KeysContext";
import PackagesContext from "contexts/PackagesContext";
import { IPackage } from "dto/IPackage";
import { useContext, useEffect, useMemo, useRef } from "react";
import { useInfiniteQuery } from "react-query";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

import Lottie from "lottie-react";

import UpssAnimation from "assets/error.json";

const DeskPackages = ({ onClick }: { onClick(pack: IPackage): void }) => {
  const { t } = useTranslation();
  const filterId = "c555b900-860a-4628-80ab-084d01076275";

  const separatorRef = useRef<HTMLDivElement>(null);

  const { packages, setPackages } = useContext(PackagesContext);
  const { keys, setKeys } = useContext(KeysContext);

  const { data, isLoading, isFetchingNextPage } = useInfiniteQuery(
    ["deskPackages", filterId],
    async ({ pageParam = "" }) => {
      const query = new URLSearchParams(window.location.search);

      query.append("Group", "true");
      query.append("IsIncoming", "true");
      query.append("SortProp", "CreationDate");
      query.append("SortOrder", "Descending");
      query.append("PageToken", pageParam);
      query.append("Desk", "true");

      const res = await axiosInstance.get(`/list?${query}`);
      return res.data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage.LastPage) {
          return lastPage.PageToken;
        }
        return undefined;
      },
    },
  );

  const compileData = async () => {
    if (!data) return;
    const packs = await Promise.all(
      data?.pages
        .map((page) => {
          return page.Items;
        })
        .flat()

      // .sort((left: IPackage, right: IPackage) => {
      //   //@ts-ignore
      //   return right.Unread - left.Unread;
      // })
    );

    const keys = await Promise.all(
      data?.pages
        .map((page) => {
          return page.ObjectKeys;
        })
        .flat()
    );

    setPackages(packs);
    setKeys(keys);
  };

  useEffect(() => {
    compileData();
  }, [data]);

  const { data: tagsData } = tagsService.useGetTags();
  const { data: statusesData } = statusService.useGetStatuses();

  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);

  const handleScroll = () => {
    if (!separatorRef.current) return;
    if (isLoading) return;
    const rect = separatorRef.current.getBoundingClientRect();
    const viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight
    );
    const isVisible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);

    if (isVisible) {
      //   setPage(page + 1);
    }
  };

  if (!packages.length) {
    return (
      <div className={styles.empty}>
        <Lottie
          style={{
            width: "100px",
          }}
          animationData={UpssAnimation}
          loop={true}
        />
        {t("desk.noCorrespondence")}
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.title}>Przychodzące</div> */}
      <div onScroll={handleScroll} className={styles.packageList}>
        {isLoading && <Loading />}
        {!isLoading &&
          packages.map((msg: IPackage) => (
            <MessageCard
              key={msg.Id}
              onDownload={() => {}}
              onPreview={() => {}}
              keys={keys}
              onClick={() => onClick(msg)}
              msg={msg}
              statuses={statuses}
              tags={tags}
              inDeskView={true}
            />
          ))}
        {isFetchingNextPage && (
          <div className={styles.loadingWrapper}>
            <Loading />
          </div>
        )}
        <div ref={separatorRef} style={{ height: "5px" }}></div>
      </div>
    </div>
  );
};

export default DeskPackages;
